import { connect } from 'react-redux';
import CurrentCompanyDataFields from '../../../../components/admin/riaContacts/acordionFields/CurrentCompanyDataFields';

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const CurrentCompanyDataFieldsContainer = connect(mapStateToProps, {})(CurrentCompanyDataFields)

export default CurrentCompanyDataFieldsContainer;